import { Component, OnInit, ViewChild } from '@angular/core';
import { SidenavComponent } from './sidenav/sidenav.component';

@Component({
  selector: 'app-navigation',
  templateUrl: './navigation.component.html',
  styleUrls: ['./navigation.component.scss']
})
export class NavigationComponent implements OnInit {

  // contiene el componente sidenav para la navegacion vertical
  @ViewChild(SidenavComponent) sidenavCmp: SidenavComponent;

  constructor() { }

  ngOnInit() {
  }

  toggleSidenav() {
    this.sidenavCmp.sidenav.toggle();
  }

}
